import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuickLinks = _resolveComponent("QuickLinks")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, {
      class: "fill-height",
      fluid: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          align: "center",
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_QuickLinks)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}